import Flex from '@deprecated-ui/common/Flex';
import If from 'global/ErrorHandlers/If';
import React from 'react';
import { Bouncer as BouncerComponent } from './styled';

export const Bouncer = ({ isLoading = true }) => (
  <If condition={isLoading}>
    <Flex>
      <BouncerComponent />
      <BouncerComponent />
      <BouncerComponent />
    </Flex>
  </If>
);

export default Bouncer;
